import { getInvoiceProperty } from 'invoices-ui-lib/utils/property';
import FormattedInvoicePropertyLabelAndValue from 'invoices-ui-lib/components/FormattedInvoicePropertyLabelAndValue';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NonNativeInvoiceHighlight = ({
  invoice,
  propertyDefinitions
}) => {
  const relevantHeaderPropertyName = getInvoiceProperty(invoice, 'hs_number') ? 'hs_number' : 'hs_title';
  const relevantStatusPropertyName = getInvoiceProperty(invoice, 'hs_status') ? 'hs_status' : 'hs_invoice_status';
  return /*#__PURE__*/_jsx("div", {
    className: "p-x-6 p-top-6 p-bottom-0",
    children: /*#__PURE__*/_jsxs("div", {
      className: "text-left m-y-4",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
          "data-test-id": "invoice-highlight-header-content",
          invoice: invoice,
          propertyDefinitions: propertyDefinitions,
          propertyName: relevantHeaderPropertyName,
          displayLabel: false
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-bottom-1",
        children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
          "data-test-id": "invoice-highlight-amount-billed-content",
          invoice: invoice,
          propertyDefinitions: propertyDefinitions,
          propertyName: "hs_amount_billed"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-bottom-1",
        children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
          "data-test-id": "invoice-highlight-status-content",
          invoice: invoice,
          propertyDefinitions: propertyDefinitions,
          propertyName: relevantStatusPropertyName
        })
      })]
    })
  });
};
export default NonNativeInvoiceHighlight;